import axios from "../../axiosInstance";


const base_url = "/ob/billing";
const base_url_Print = "/Reports"

const BillEntryService = {

      getEntry: () => {
            return axios.get(base_url+"/getExportEntry?export_id=-1");
          },
      insertEntry: (iar) => {
            return axios.post(base_url+"/insertExportEntry",iar);
          },
      updateEntry: (updateData) => {
            return axios.put(base_url+"/updateExportEntry",updateData);
          },
      getAddDetails(blno) {
            return axios.get(base_url+"/getExportEntryDetails?entry_ds_id="+blno);
          },
      insertAddDetails: (iad) => {
            return axios.post(base_url+"/insertExportEntryDetails",iad);
          },
      updateAddDetails: (updateAddDetails) => {
            return axios.put(base_url+"/updateExportEntryDetails",updateAddDetails);
          },
      InvoicePdf:(data)=>{
            return axios.post(base_url_Print + "/BILL_Pdf",data);
          },

}
export default BillEntryService;
